export enum HandingType {
    HINGE = 1,
    PANEL = 2,
    DRAWER = 3,
    QUADRANT = 4
}
